import React from 'react';
import { useTranslation } from 'react-i18next';
import { Message, Button, Modal, CheckboxLabel } from '@weezevent/nacre';
import LoadingCard from '../../../../components/loadingCard';

function ValidationModal({ form, setForm, handleSubmit, onConstructAttendees, order, isSubmitting }) {
    const { t } = useTranslation();

    const handleCancel = React.useCallback(() => {
        setForm('validationModal', false);
    }, [setForm]);

    const handleValidationOptionsChange = React.useCallback(
        (e, { value, checked }) => {
            setForm(value, checked);
        },
        [setForm]
    );

    React.useEffect(() => {
        if (order && !form.attendees.length) {
            onConstructAttendees();
        }
    }, [order, form.attendees]);

    return (
        <>
            <Modal
                allowExternalClosing={false}
                size="medium"
                open={form.validationModal}
                onClose={handleCancel}
                submitButton={<Button disabled={isSubmitting} primary label={t('ticket.common.action.save')} onClick={handleSubmit} />}
                cancelButton={<Button disabled={isSubmitting} label={t('ticket.common.action.cancel')} onClick={handleCancel} />}
                title={t('attendees.addAttendees.modal.title')}
                subtitle={t('attendees.addAttendees.modal.subtitle')}
            >
                {isSubmitting ? (
                    <LoadingCard loading />
                ) : (
                    <>
                        <Message type="default" title={t('attendees.addAttendees.modal.message.title')}>
                            {t('attendees.addAttendees.modal.message.subtitle')}
                        </Message>

                        <CheckboxLabel label={t('attendees.addAttendees.modal.download')} value="downloadPDF" onChange={handleValidationOptionsChange} />
                        <CheckboxLabel label={t('attendees.addAttendees.modal.send')} value="sendEmail" onChange={handleValidationOptionsChange} />
                    </>
                )}
            </Modal>
        </>
    );
}

export default ValidationModal;
